import SingleSelectWithSearch from "../../../components/dropdown/SingleSelectWithSearch";
import TextInput from "../../../components/UIComponent/TextInput";
import ModalBasic from "../../component/ModalBasic";

export const TdsEntryPopUp = (props) => {
    return (
        <ModalBasic
            id="voucher-receipt-details"
            classParams="!w-[75%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className="input-fields bg-white p-[30px] shadow-normalShadow rounded-[10px]">
                <div className="item-grp">
                    <span className="text-blue text-[16px] font-semibold">Receipt details</span>
                    <div className="item-inner grid grid-cols-4 gap-2.5 mt-[5px]">
                        <div className="input-grp">
                            <label>Receipt no</label>
                            <TextInput type="number" id="receiptNo" name="receiptNo" value={props.receiptDetails.receiptNo} handleChange={(event) => props.handleChange(event, "receiptNo")} disabled />
                        </div>
                        <div className="input-grp">
                            <label>Payment date</label>
                            <TextInput type="date" id="date" name="date" value={props.receiptDetails.paymentDate} handleChange={(event) => props.handleChange(event, "date")} className={props.validState?.error?.paymentDate !== undefined ? "error" : ""}/>
                        </div>
                        <div className="input-grp">
                            <label>Type</label>
                            <SingleSelectWithSearch id="type" name="type" value={props.receiptDetails.type} handleChangeTest={(event) => props.handleSelectChange(event, "type")} className={props.validState?.error?.type !== undefined ? "error" : ""}/>
                        </div>
                        <div className="input-grp">
                            <label>Account head</label>
                            <SingleSelectWithSearch id="accHead" name="accHead" value={props.receiptDetails.accHead} handleChangeTest={(event) => props.handleSelectChange(event, "accHead")} className={props.validState?.error?.accHead !== undefined ? "error" : ""}/>
                        </div>
                    </div>
                    <div className="item-inner grid grid-cols-4 gap-2.5 mt-2.5 mb-3 pb-[10px] border-b border-slate-200">
                        <div className="input-grp">
                            <label>From date</label>
                            <TextInput type="date" id="fromDate" name="fromDate" value={props.receiptDetails.fromDate} handleChange={(event) => this.props.handleChange(event, "fromDate")} className={props.validState?.error?.fromDate !== undefined ? "error" : ""}/>
                        </div>
                        <div className="input-grp">
                            <label>To date</label>
                            <TextInput type="date" id="toDate" name="toDate" value={props.receiptDetails.toDate} handleChange={(event) => this.props.handleChange(event, "toDate")} className={props.validState?.error?.toDate !== undefined ? "error" : ""}/>
                        </div>
                        <div className="inputOuter-grp col-span-2 flex gap-2.5">
                            <div className="input-grp w-[70%]">
                                <label>Select vendor</label>
                                <SingleSelectWithSearch id="selectVendor" name="selectVendor" value={props.receiptDetails.selectVendor} handleChangeTest={(event) => props.handleSelectChange(event, "selectVendor")} className={props.validState?.error?.selectVendor !== undefined ? "error" : ""}/>
                            </div>
                            <div className="input-grp w-[30%]">
                                <label>TDS(%)</label>
                                <TextInput type="number" id="tds" name="tds" value={props.receiptDetails.tds} handleChange={(event) => props.handleChange(event, "tds")} className={props.validState?.error?.tds !== undefined ? "error" : ""}/>
                            </div>
                        </div>
                    </div>
                    <div className="item-inner grid grid-cols-4 gap-2.5 mb-3.5">
                        <div className="input-grp">
                            <label>Payble amount</label>
                            <TextInput type="number" id="paybleAmount" name="paybleAmount" value={props.receiptDetails.paybleAmount} handleChange={(event) => props.handleChange(event, "paybleAmount")} className={props.validState?.error?.paybleAmount !== undefined ? "error" : ""}/>
                        </div>
                        <div className="input-grp">
                            <label>TDS amount</label>
                            <TextInput type="number" id="tdsAmount" name="tdsAmount" value={props.receiptDetails.tdsAmount} handleChange={(event) => props.handleChange(event, "tdsAmount")} className={props.validState?.error?.tdsAmount !== undefined ? "error" : ""}/>
                        </div>
                        <div className="input-grp col-span-2">
                            <label>Remarks</label>
                            <TextInput type="text" id="remarks" name="remarks" value={props.receiptDetails.remarks} handleChange={(event) => props.handleChange(event, "remarks")} />
                        </div>
                    </div>
                    <div className="btn-grp inline-flex gap-2.5">
                        <button className="update-btn btns">Save</button>
                        <button className="delete-btn btns" onClick={() => props.closeModal}>Close</button>
                    </div>
                </div>
            </div>
        </ModalBasic>
    );
}

export const rowData = [
    {
        idTdsReceipt: 101,
        srNo: 1,
        ReceiptNo: "TDSR001",
        Date: "2024-02-01",
        IdVendor: "V001",
        partyAcName: "ABC Pvt Ltd",
        tdsPerc: 10,
        fromDate: "2024-01-01",
        toDate: "2024-01-31",
        paybleAmount: 50000,
        tdsAmount: 5000,
        remarks: "Quarterly TDS payment",
    },
    {
        idTdsReceipt: 102,
        srNo: 2,
        ReceiptNo: "TDSR002",
        Date: "2024-02-02",
        IdVendor: "V002",
        partyAcName: "XYZ Ltd",
        tdsPerc: 5,
        fromDate: "2024-01-10",
        toDate: "2024-01-25",
        paybleAmount: 40000,
        tdsAmount: 2000,
        remarks: "Monthly deduction",
    },
    {
        idTdsReceipt: 103,
        srNo: 3,
        ReceiptNo: "TDSR003",
        Date: "2024-02-03",
        IdVendor: "V003",
        partyAcName: "LMN Corp",
        tdsPerc: 7,
        fromDate: "2024-01-05",
        toDate: "2024-01-20",
        paybleAmount: 60000,
        tdsAmount: 4200,
        remarks: "Service charges deduction",
    },
    {
        idTdsReceipt: 104,
        srNo: 4,
        ReceiptNo: "TDSR004",
        Date: "2024-02-04",
        IdVendor: "V004",
        partyAcName: "PQR Solutions",
        tdsPerc: 8,
        fromDate: "2024-01-15",
        toDate: "2024-01-30",
        paybleAmount: 70000,
        tdsAmount: 5600,
        remarks: "Consultancy charges",
    },
    {
        idTdsReceipt: 105,
        srNo: 5,
        ReceiptNo: "TDSR005",
        Date: "2024-02-05",
        IdVendor: "V005",
        partyAcName: "DEF Industries",
        tdsPerc: 6,
        fromDate: "2024-01-01",
        toDate: "2024-01-31",
        paybleAmount: 55000,
        tdsAmount: 3300,
        remarks: "TDS on contract",
    },
    {
        idTdsReceipt: 106,
        srNo: 6,
        ReceiptNo: "TDSR006",
        Date: "2024-02-06",
        IdVendor: "V006",
        partyAcName: "MNO Enterprises",
        tdsPerc: 9,
        fromDate: "2024-01-05",
        toDate: "2024-01-25",
        paybleAmount: 80000,
        tdsAmount: 7200,
        remarks: "Quarterly deduction",
    },
    {
        idTdsReceipt: 107,
        srNo: 7,
        ReceiptNo: "TDSR007",
        Date: "2024-02-07",
        IdVendor: "V007",
        partyAcName: "GHI Tech",
        tdsPerc: 5,
        fromDate: "2024-01-10",
        toDate: "2024-01-20",
        paybleAmount: 30000,
        tdsAmount: 1500,
        remarks: "Software services",
    },
    {
        idTdsReceipt: 108,
        srNo: 8,
        ReceiptNo: "TDSR008",
        Date: "2024-02-08",
        IdVendor: "V008",
        partyAcName: "STU Ltd",
        tdsPerc: 10,
        fromDate: "2024-01-01",
        toDate: "2024-01-31",
        paybleAmount: 100000,
        tdsAmount: 10000,
        remarks: "Annual payment deduction",
    },
    {
        idTdsReceipt: 109,
        srNo: 9,
        ReceiptNo: "TDSR009",
        Date: "2024-02-09",
        IdVendor: "V009",
        partyAcName: "JKL Services",
        tdsPerc: 7,
        fromDate: "2024-01-10",
        toDate: "2024-01-30",
        paybleAmount: 65000,
        tdsAmount: 4550,
        remarks: "Service tax deduction",
    },
    {
        idTdsReceipt: 110,
        srNo: 10,
        ReceiptNo: "TDSR010",
        Date: "2024-02-10",
        IdVendor: "V010",
        partyAcName: "UVW Solutions",
        tdsPerc: 8,
        fromDate: "2024-01-05",
        toDate: "2024-01-25",
        paybleAmount: 75000,
        tdsAmount: 6000,
        remarks: "Consulting services",
    },
];
export const colDefs = [
    {
        field: "idTdsReceipt",
        headerName: "ID TDS Receipt",
        minWidth: window.innerWidth * 0.08,
        flex: 1,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "srNo",
        headerName: "Sr No",
        minWidth: window.innerWidth * 0.04,
        flex: 1,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "receiptNo",
        headerName: "Receipt No",
        minWidth: window.innerWidth * 0.08,
        flex: 1,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "date",
        headerName: "Date",
        minWidth: window.innerWidth * 0.06,
        flex: 1,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "IdVendor",
        headerName: "ID Vendor",
        minWidth: window.innerWidth * 0.06,
        flex: 1,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "partyAcName",
        headerName: "Party AC Name",
        minWidth: window.innerWidth * 0.15,
        flex: 1.5,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "tdsPerc",
        headerName: "TDS Perc",
        minWidth: window.innerWidth * 0.05,
        flex: 1,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "fromDate",
        headerName: "From Date",
        minWidth: window.innerWidth * 0.06,
        flex: 1,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "toDate",
        headerName: "To Date",
        minWidth: window.innerWidth * 0.06,
        flex: 1,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "paybleAmount",
        headerName: "Payble Amount",
        minWidth: window.innerWidth * 0.07,
        flex: 1,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "tdsAmount",
        headerName: "TDS Amount",
        minWidth: window.innerWidth * 0.07,
        flex: 1,
        filter: true,
        floatingFilter: true,
    },
    {
        field: "remarks",
        headerName: "Remarks",
        minWidth: window.innerWidth * 0.12,
        flex: 1,
        filter: true,
        floatingFilter: true,
    },
];